import React from 'react';
import { useAuth } from '../context/AuthContext';
import './MaintenancePage.css';

const MaintenancePage = () => {
  const { logout } = useAuth();
  
  return (
    <div className="maintenance-container">
      <div className="maintenance-card">
        <div className="maintenance-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
          </svg>
        </div>
        <h1 className="maintenance-title">Sistema en Mantenimiento</h1>
        <p className="maintenance-message">
          Estamos realizando tareas de mantenimiento programado para mejorar nuestro servicio. 
          Por favor, intente acceder más tarde.
        </p>
        <div className="maintenance-footer">
          <p>Disculpe las molestias ocasionadas.</p>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button className="btn-secondary" onClick={logout}>
              Cerrar Sesión
            </button>
            <button className="btn-primary" onClick={() => window.location.reload()}>
              Reintentar Conexión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
